var _path, _path2, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 64,
    viewBox: "0 0 91 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.694 28.8806C71.694 44.8309 58.7637 57.7612 42.8134 57.7612C26.8631 57.7612 13.9328 44.8309 13.9328 28.8806C13.9328 12.9303 26.8631 0 42.8134 0C58.7637 0 71.694 12.9303 71.694 28.8806Z",
    fill: "#C1C1C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23134 41.9776C9.23134 44.3887 7.27677 46.3433 4.86567 46.3433C2.45458 46.3433 0.5 44.3887 0.5 41.9776C0.5 39.5665 2.45458 37.6119 4.86567 37.6119C7.27677 37.6119 9.23134 39.5665 9.23134 41.9776Z",
    fill: "#C1C1C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5 56.4179C90.5 60.4982 87.1923 63.806 83.1119 63.806C79.0316 63.806 75.7239 60.4982 75.7239 56.4179C75.7239 52.3376 79.0316 49.0299 83.1119 49.0299C87.1923 49.0299 90.5 52.3376 90.5 56.4179Z",
    fill: "#C1C1C1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1252_19776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.5053 26.8684L70.5533 39.7438H50.5104L46.2323 18.3535H38.5V21.562H43.602L47.88 42.9524H72.7569L78.5 28.0203L75.5053 26.8684ZM53.4733 44.022C50.8195 44.022 48.6605 46.1809 48.6605 48.8348C48.6605 51.4887 50.8195 53.6476 53.4733 53.6476C56.1271 53.6476 58.2861 51.4887 58.2861 48.8348C58.2861 46.1809 56.127 44.022 53.4733 44.022ZM53.4733 50.4391C52.5887 50.4391 51.869 49.7195 51.869 48.8348C51.869 47.9501 52.5887 47.2305 53.4733 47.2305C54.3579 47.2305 55.0776 47.9501 55.0776 48.8348C55.0776 49.7195 54.3579 50.4391 53.4733 50.4391ZM67.377 44.022C64.7232 44.022 62.5642 46.1809 62.5642 48.8348C62.5642 51.4887 64.7233 53.6476 67.377 53.6476C70.0309 53.6476 72.1898 51.4887 72.1898 48.8348C72.1898 46.1809 70.0308 44.022 67.377 44.022ZM67.377 50.4391C66.4924 50.4391 65.7727 49.7195 65.7727 48.8348C65.7727 47.9501 66.4924 47.2305 67.377 47.2305C68.2616 47.2305 68.9813 47.9501 68.9813 48.8348C68.9813 49.7195 68.2616 50.4391 67.377 50.4391Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.5 27C67.5 31.3131 64.4286 34.5 61 34.5C57.5714 34.5 54.5 31.3131 54.5 27C54.5 22.6869 57.5714 19.5 61 19.5C64.4286 19.5 67.5 22.6869 67.5 27Z",
    stroke: "black",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1252_19776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(38.5 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTicketIcon);
export default __webpack_public_path__ + "static/media/no-ticket-icon.4ebb2ba5b7301d0fc420c758a14668c4.svg";
export { ForwardRef as ReactComponent };